import React from 'react';
import PerfectScrollbar from "perfect-scrollbar";

export default class ScrollContainer extends React.Component {

    ps;
    componentDidMount() {
        if (navigator.platform.indexOf("Win") > -1) {
            this.ps = new PerfectScrollbar(this.refs.sidebarWrapper, {
                suppressScrollX: true,
                suppressScrollY: false
            });
        }
    }
    componentWillUnmount() {
        if (navigator.platform.indexOf("Win") > -1) {
            this.ps.destroy();
        }
    }
    render() {
        const { className, children, style } = this.props;
        return (
            <div className={className} ref="sidebarWrapper" style={{
                ...{
                    position: "relative",
                    overflow: "auto",
                    zIndex: "4",
                    overflowScrolling: "touch",
                    transitionProperty: "top, bottom, width",
                    transitionDuration: ".2s, .2s, .35s",
                    transitionTimingFunction: "linear, linear, ease",
                    color: "inherit",
                    //paddingBottom: "30px"
                },
                ...style
            }}>
                {children}
            </div>
        );
    }
}